<template>
    <div class="p-6 bg-01173E text-white min-h-screen">
        <Mainlayout></Mainlayout>
        <div style="width:85%;margin:0 auto">
        <div class="flex flex-wrap md:flex-nowrap gap-8">
            <br /> <br /> <br /> <br />
            <!-- Left Content -->
            
          <CRow>
            <CCol sm="8">
                <div class="w-full md:w-1/2 space-y-4 text-left">
                <h1 class="custom-24px-600 text-white font-inter font-semibold">Transaction</h1>
                    <h4 class="custom-16px-400 font-semibold font-inter text-left mb-5 text-white">2 transaction in your cart</h4>
                    <div class="p-4 custom-bg-blue-black">
                        <table class="table table-responsive-sm">
                            <thead>
                                <th class="text-white">Order</th>
                                <th class="text-white">Price</th>
                                <th class="text-white">Discount</th>
                                <th class="text-white">Total Price</th>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <CRow>
                                            <CCol sm="4">
                                                <img src="../assets/img/flyhigh/p1.png" style="max-width: 100%;" />
                                            </CCol>
                                            <CCol sm="8">
                                                <h5 class="text-white custom-18px-600">TAHUN 3 (DARJAH 3) TROPIKAL PREMIUM TAH</h5>
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td class="text-nowrap">
                                        <h5 class="text-5xl text-white d-flex">RM 300.00</h5>
                                    </td>
                                    <td class="text-nowrap">
                                        <h5 class="text-5xl text-white d-flex">RM 100.00</h5>
                                    </td>
                                    <td class="text-nowrap">
                                        <h5 class="text-5xl text-white d-flex">RM 200.00</h5>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <CRow>
                                            <CCol sm="4">
                                                <img src="../assets/img/flyhigh/p1.png" style="max-width: 100%;" />
                                            </CCol>
                                            <CCol sm="8">
                                                <h5 class="custom-18px-600 text-white">TAHUN 3 (DARJAH 3) TROPIKAL PREMIUM TAH</h5>
                                            </CCol>
                                        </CRow>
                                    </td>
                                    <td class="text-nowrap">
                                        <h5 class="text-5xl text-white d-flex">RM 300.00</h5>
                                    </td>
                                    <td class="text-nowrap">
                                        <h5 class="text-5xl text-white d-flex">RM 100.00</h5>
                                    </td>
                                    <td class="text-nowrap">
                                        <h5 class="text-5xl text-white d-flex">RM 200.00</h5>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                  
                    </div>
                </div>
            </CCol>
            <CCol sm="4">
                <div class="p-4 custom-bg-blue-black">
                    <div class="m-3">
                                                            <h4 class="custom-24px-600 font-inter text-white"><strong>Calculation Price</strong></h4>
                                                            <CRow>
                                                               
                                                                <CCol sm="12">
                                                                    <CRow>
                                                                        <CCol sm="6" class="mt-4">
                                                                            Cart Subtotal
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-4">
                                                                          RM33
                                                                        </CCol>
                                                                        <CCol sm="6" class="mt-4">
                                                                            Discount
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-4">
                                                                          RM33
                                                                        </CCol>
                                                                        <CCol sm="6" class="mt-4">
                                                                            Fee Student
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-4">
                                                                          RM33
                                                                        </CCol>
                                                                        <CCol sm="6" class="mt-4">
                                                                            Total
                                                                        </CCol>
                                                                        <CCol sm="6" class="text-right mt-4">
                                                                           RM444
                                                                        </CCol>
                                                                        <CCol sm="12" class="mt-2">
                                                                            <hr />
                                                                        </CCol>
                                                                        <CCol sm="12" class="mt-2">
                                                                            Coupon Code
                                                                        </CCol>
                                                                        <CCol sm="12" class="text-right mt-2">
                                                                            <div class="input-button-container">
                                                                    
                                                                        <p class="custom-16px-400">Expand discounts to enjoy various other benefits</p>
                                                                        <CInput type="text" v-model="discount" class="input-blue"/>
                                                                      
                                                                    </div>
                                                                    <button class="w-full mt-4 bg-blue-500 hover:bg-blue-600 text-white py-2 rounded bg-1796FD">
                                Order Now
                              </button>
                                                                        </CCol>
                                                                    </CRow>
                                                                </CCol>
                                                            </CRow>
                                                        </div>
                </div>
            </CCol>
          </CRow>
                   
    
    
    
           
    
            <!-- Right Content -->
    
        </div>
    
        </div>
        <Footer />
    </div>
</template>
  
<script>
import Mainlayout from "../containers/AllHeader.vue";
import Footer from '@/components/Footer.vue'
export default {
    components: {
        Mainlayout,
        Footer
    },
    data() {
        return {
            orderInfo: [
                { day: '01', course: 'Programming...', date: '12/03/2025', time: '2:30 PM' },
                { day: '02', course: 'Basic Algorithm', date: '12/03/2025', time: '9:00 AM' },
                { day: '03', course: 'Advanced Algo...', date: '12/03/2025', time: '11:15 AM' },
                { day: '04', course: 'Complex Algor...', date: '12/03/2025', time: '3:45 PM' },
            ]
        }
    }
}
</script>
  
<style scoped>
.bg-dark {
    background-color: #0d1117;
}
</style>
